import FlexBox from '@/atomic-components/FlexBox';
import { LencoImage } from '@/atomic-components/Image';
import { ICartItem } from '@/services/cart/models/cart';
import { IconButton } from '@mui/material';
import { Box } from '@mui/system';
import CartItemSummary from './CartItemSummary';
import DeleteIcon from '@/assets/DeleteIcon.svg';
import { getStyle } from '@/utils/theme/fonts';
import { getColor } from '@/utils/theme/colors';

type TCartItemProps = {
	item: ICartItem;
	onDeleteClicked?: (item: ICartItem) => void;
	onUpdateItemQuantity?: (
		item: ICartItem,
		targetQuantity: number
	) => Promise<any>;
	Actions: React.ReactElement;
	Footer?: React.ReactElement;
	onItemClicked?: () => void;
};

const CartItem = (props: TCartItemProps) => {
	const { item } = props;

	function canShowDeleteButton() {
		return props.onDeleteClicked && typeof props.onDeleteClicked == 'function';
	}
	const LOPMappings = {
		BUY_NEW: {
			color: 'Navy -4',
			text: 'BRAND NEW',
		},
		BUY_REFURBISHED: {
			color: 'Minty -4',
			text: 'REFURBISHED',
		},
	};
	function deleteIconClicked(e: any) {
		e.preventDefault();
		props.onDeleteClicked && props.onDeleteClicked(item);
	}

	return (
		<Box>
			<FlexBox
				p='24px 32px'
				alignItems={'center'}
				justifyContent={'space-between'}
				width='100%'
				position='relative'
			>
				<FlexBox
					className='cursor-pointer'
					onClick={() => {
						props.onItemClicked && props.onItemClicked();
					}}
					width='100%'
					justifyContent='space-between'
				>
					<Box
						className='cart-item-image'
						width='113px'
						mr='16px'
						sx={{ minWidth: '113px' }}
					>
						<LencoImage aspectRatio={113 / 77} url={item.product.image} />

						{item?.vertical === 'FURLENCO_SALE' && (
							<Box
								sx={{
									...getStyle('Tiny_Medium'),
									borderRadius: '0px 8px 8px 0px',
									background: getColor(
										LOPMappings[item?.lineOfProduct as keyof typeof LOPMappings]
											.color
									),

									color: getColor('gray 0'),
									position: 'absolute',
									bottom: 11,
									left: 0,
									padding: '5px 15px',
									margin: 0,
								}}
							>
								{
									LOPMappings[item?.lineOfProduct as keyof typeof LOPMappings]
										.text
								}
							</Box>
						)}
					</Box>

					<FlexBox justifyContent='space-between' width='100%'>
						<CartItemSummary item={item} />
						{props.Actions}
					</FlexBox>
				</FlexBox>
				{canShowDeleteButton() && (
					<Box sx={{ marginBottom: '1rem' }}>
						<IconButton
							className='cart-item-delete-button'
							onClick={deleteIconClicked}
						>
							<DeleteIcon />
						</IconButton>
					</Box>
				)}
			</FlexBox>
			{props.Footer}
		</Box>
	);
};

export default CartItem;
